import { render } from "./heatingExpansion.vue?vue&type=template&id=6442b57a&scoped=true"
import script from "./heatingExpansion.vue?vue&type=script&lang=js"
export * from "./heatingExpansion.vue?vue&type=script&lang=js"

import "./heatingExpansion.vue?vue&type=style&index=0&id=6442b57a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6442b57a"]])

export default __exports__